import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["title", "aria-label"]
const _hoisted_2 = {
  key: 0,
  width: "13",
  height: "13",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2.4",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_3 = {
  key: 1,
  width: "14",
  height: "11",
  viewBox: "0 0 16 11",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.8",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_4 = {
  key: 2,
  width: "18",
  height: "11",
  viewBox: "0 0 20 11",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.8",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}

import { computed } from 'vue'
import type { DeliveryStatus } from '@/services/wootdashConversations'


export default /*@__PURE__*/_defineComponent({
  __name: 'MessageTicks',
  props: {
    status: {},
    error: {}
  },
  setup(__props: any) {

// Tiques do WhatsApp numa mensagem nossa: ✓ enviada, ✓✓ entregue, ✓✓ azul lida, ⚠ não entregue (motivo no
// título). Vem de "StatusMensagem" (SignalR) e de deliveryStatus na busca. Sem status = não saiu pelo WhatsApp
// (nota interna, histórico antigo) — não mostra nada.
const props = __props

const title = computed(() => ({
  sent: 'Enviada',
  delivered: 'Entregue',
  read: 'Lida',
  failed: `Não entregue${props.error ? ` — ${props.error}` : ''}`,
}[props.status ?? 'sent']))

return (_ctx: any,_cache: any) => {
  return (__props.status)
    ? (_openBlock(), _createElementBlock("span", {
        key: 0,
        class: _normalizeClass(["msg-ticks", `msg-ticks--${__props.status}`]),
        title: title.value,
        role: "img",
        "aria-label": title.value
      }, [
        (__props.status === 'failed')
          ? (_openBlock(), _createElementBlock("svg", _hoisted_2, [...(_cache[0] || (_cache[0] = [
              _createElementVNode("circle", {
                cx: "12",
                cy: "12",
                r: "10"
              }, null, -1),
              _createElementVNode("line", {
                x1: "12",
                y1: "7",
                x2: "12",
                y2: "13"
              }, null, -1),
              _createElementVNode("line", {
                x1: "12",
                y1: "17",
                x2: "12.01",
                y2: "17"
              }, null, -1)
            ]))]))
          : (__props.status === 'sent')
            ? (_openBlock(), _createElementBlock("svg", _hoisted_3, [...(_cache[1] || (_cache[1] = [
                _createElementVNode("polyline", { points: "1.5 6 5 9.5 12.5 1.5" }, null, -1)
              ]))]))
            : (_openBlock(), _createElementBlock("svg", _hoisted_4, [...(_cache[2] || (_cache[2] = [
                _createElementVNode("polyline", { points: "1.5 6 5 9.5 12.5 1.5" }, null, -1),
                _createElementVNode("polyline", { points: "8 8.5 9 9.5 16.5 1.5" }, null, -1)
              ]))]))
      ], 10, _hoisted_1))
    : _createCommentVNode("", true)
}
}

})